export enum AdressatLinkRel {
	DELETE = 'delete',
	DOWNLOAD_KORRESPONDENZ = 'downloadKorrespondenz',
	NOTIZ = 'notiz',
	KONTAKT = 'kontakt',
}

export enum AdressatListLinkRel {
	ADRESSAT_LIST = 'adressatList',
}
